import React, { Component } from 'react';
import ClientBasicForm from '../../components/Admin/Client/index'
import ClientBranchForm from '../../components/Admin/Client/branch'
import ProductPriceForm from '../../components/Admin/Client/price'
import PropTypes from 'prop-types'


const submit = (values) => {
}
class NewClient extends Component {
    constructor(args) {
        super(args)
        this.state = { page : 1};
        this.nextPage = this.nextPage.bind(this)
        this.previousPage = this.previousPage.bind(this)
    }

    nextPage() {
        this.setState({ page: this.state.page + 1 })
      }
    
      previousPage() {
        this.setState({ page: this.state.page - 1 })
      }
    render(){
        const { onSubmit } = this.props
        const { page } = this.state
        return (
            <>
                {(page == 1 && <ClientBasicForm onSubmit={this.nextPage}/>)}
                {(page == 2 && <ClientBranchForm  previousPage={this.previousPage} onSubmit={this.nextPage}/>)}
                {(page == 3 && <ProductPriceForm  previousPage={this.previousPage} onSubmit={onSubmit} mainSubmit={submit}/>)}
            </>
        )
    }
}
NewClient.propTypes = {
    onSubmit: PropTypes.func.isRequired
  }
  
export default NewClient

